import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {Client} from '@gatewee/types/client';
import {UtilsModule} from '@gatewee/utils';
import {TranslateModule} from '@ngx-translate/core';
import {ComponentsV1Module} from '../../v1/components-v1.module';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-invoice-client-info',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    ComponentsV1Module,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
  ],
  templateUrl: './gatewee-invoice-client-info.component.html',
  styleUrls: [
    './gatewee-invoice-client-info.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeInvoiceClientInfoComponent {
  @Input() client: Client | null | undefined;
}
